const X = ({ color = 'black', variant = 'filled', strokeWidth = 1  }) => {
    if (variant === 'outlined') {
        return (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect stroke-width={strokeWidth} x="0.0311279" y="0.125" width="32" height="32" fill="none"/>
                <path stroke-width={strokeWidth} d="M21.0433 27.625L5.23938 4.625H11.0189L26.8229 27.625H21.0433Z" stroke={color}/>
                <path stroke-width={strokeWidth} d="M13.4575 17.4682L4.28915 28.125H6.36095L14.3773 18.8067L13.4575 17.4682Z" fill={color}/>
                <path stroke-width={strokeWidth} d="M25.1655 4.625H25.918L18.3096 13.4692L17.9752 12.9829L25.1655 4.625Z" stroke={color}/>
            </svg>
        );
    }

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.822937" y="0.125" width="32" height="32" fill="none"/>
            <path d="M19.0571 14.2874L27.7995 4.125H25.7278L18.1368 12.9488L12.0739 4.125H5.08096L14.2493 17.4682L5.08096 28.125H7.15276L15.1691 18.8067L21.572 28.125H28.5649L19.0571 14.2874Z" fill={color}/>
        </svg>
    )

}

export default X;
